
import common from './en/common';
import navigation from './en/navigation';
import app from './en/app';
import dashboard from './en/dashboard';
import pricing from './en/pricing';
import engine from './en/engine';
import about from './en/about';
import landing from './en/landing';
import dialogs from './en/dialogs';
import match from './en/match';
import stats from './en/stats';
import predictions from './en/predictions';
import errors from './en/errors';
import tickets from './en/tickets';
import forms from './en/forms';
import account from './en/account';
import auth from './en/auth';
import settings from './en/settings';

const en = {
  ...common,
  ...navigation,
  ...app,
  ...dashboard,
  ...pricing,
  ...engine,
  ...about,
  ...landing,
  ...dialogs,
  ...match,
  ...stats,
  ...predictions,
  ...errors,
  ...tickets,
  ...forms,
  ...account,
  ...auth,
  ...settings
};

export default en;
